import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './style.css';

import { Provider, connect } from 'react-redux';
import { SET_FOCUSED_ISLAND, LOG } from './redux/Actions/Types';
import store from './redux/store';

import XLSX from 'xlsx';

import proj4 from 'proj4';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { SyncLoader } from 'react-spinners';

import { api, apiConst } from './backend/api.js'

import Account from './smart_component/Account.jsx';
import DatabaseImporter from './smart_component/DatabaseImporter.jsx';
import MainInterface from './smart_component/MainInterface.jsx';
import { Mask, ServerLoading } from './dumb_component';

import { handleDrop } from './batchPut.jsx';
import { DATABASE } from './backend/model';
import { SiteLogo } from './dumb_component';

//console.log = function(){};

if(!document.getElementById('root')){
  const element = document.createElement('div');
  element.setAttribute('id', 'root');

  const leafletStyle = document.createElement('link');
  leafletStyle.setAttribute('rel', 'stylesheet');
  leafletStyle.setAttribute('href', 'https://unpkg.com/leaflet@1.6.0/dist/leaflet.css');
  leafletStyle.setAttribute('integrity', 'sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ==')
  leafletStyle.setAttribute('crossorigin', '');
  
  document.head.appendChild(leafletStyle);
  document.body.appendChild(element);
}

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workbook: {},
      database: {},
      searchAnswers: null,
      showConnection: false,
      searchReadyDatabase: {},
      mockIsland: {},
      islandCollection: {},
      loadingExcel: false,
      sneakPeak: {},
      serverProcessing: false
    }
  }



  componentDidMount() {
    proj4.defs("EPSG:2154","+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");

    api(apiConst.INIT, {database: DATABASE}, (r) => {

      //if(!!r.snUID)
        //window.localStorage.setItem('snUID', r.snUID);

      //if(!!r.sneakPeak)
        //window.localStorage.setItem('sneakPeak', JSON.stringify(r.sneakPeak));

      window.localStorage.setItem('forbiddenWords', JSON.stringify(r.forbiddenWords));
      console.log("Resp", r)

      let sr = this.formatSearchReadyString(r.searchReady, r.forbiddenWords);
      this.setState({
        searchReadyDatabase: sr,
        sneakPeak: r.sneakPeak
      });
    });

    let storage = window.localStorage;
    let database = storage.getItem('database');
    let islandCollection = storage.getItem('islandCollection');
    let mockIsland = {};

    Object.keys(DATABASE).forEach(key => {
      mockIsland[key] = {};
      Object.keys(DATABASE[key]).forEach(innerKey =>  mockIsland[innerKey] = innerKey);
    });

      /**
     * Pour extraire le model en excel
     */
    // start
    /*
    let wb = XLSX.utils.book_new();
    let db = DATABASE;
    console.log(db)
    Object.keys(db).forEach(sheet => {
      console.log(sheet)
      let arr = [[]];
      if(sheet == 'NOM_ILOTS')
        arr[0].push('HISTOLITT_V2')
      else if(sheet != 'ID')
        arr[0].push('HISTOLITT_V2', 'IGN');
      Object.keys(db[sheet]).forEach(v => {
        arr[0].push(v)})
      let ws = XLSX.utils.aoa_to_sheet(arr);
      XLSX.utils.book_append_sheet(wb, ws, sheet);
    })
    XLSX.writeFile(wb, 'Model de base de données îles & îlots de Bretagne.xlsx');
    */
    //end
    console.log('database is', database);
    this.setState({mockIsland});

    if(database) {
      database = JSON.parse(database);
      islandCollection = JSON.parse(islandCollection);
      console.log('database is', database);

      this.setState({
        database,
        mockIsland,
        islandCollection
      });
    };
  };

  urlGet = (param) => {
    var vars = {};
    window.location.href.replace( location.hash, '' ).replace( 
      /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
      function( m, key, value ) { // callback
        vars[key] = value !== undefined ? value : '';
      }
    );

    if ( param ) {
      return vars[param] ? vars[param] : null;	
    }
    return vars;
  }

  perm = (xs) => {
    let ret = [];
    for (let i = 0; i < xs.length; i = i + 1) {
      let rest = this.perm(xs.slice(0, i).concat(xs.slice(i + 1)));
      if(!rest.length) {
        ret.push([xs[i]])
      } else {
        for(let j = 0; j < rest.length; j = j + 1) {
          ret.push([xs[i]].concat(rest[j]))
        }
      }
    }
    return ret;
  }

  formatSearchReadyString(obj, forbiddenWords) {
    console.log("SR", obj)
    Object.keys(obj).forEach(key => { 
      let concatStr = obj[key].toLowerCase();

      let aRegex = /[àâä]/g;
      let eRegex = /[éèêë]/g;
      let iRegex = /[îï]/g;
      let oRegex = /[ôö]/g;
      let uRegex = /[ûüù]/g;

      let accentLess = concatStr.replace(aRegex, 'a');
      accentLess = accentLess.replace(eRegex, 'e');
      accentLess = accentLess.replace(iRegex, 'i');
      accentLess = accentLess.replace(oRegex, 'o');
      accentLess = accentLess.replace(uRegex, 'u');

      forbiddenWords.forEach(word => {
        console.log(word);
        let tmp = '\\b' + word + '\\b';
        let r  = new RegExp(tmp, 'g');
        console.log(r)
        accentLess = accentLess.replace(r, '');
      });

      accentLess = accentLess.replace(/,/g, ' ')
      accentLess = accentLess.replace(/  /g, ' ')

      obj[key] = accentLess;
    });

    return obj;
  }

  searchFor = tx => {
    let a = document.getElementById('mi-side-welcome');
    let b = document.getElementById('header-title');
   
    if(tx[0] == undefined || tx.length < 3) {
      this.setState({searchAnswers: null});
      return;
    }

    if(tx[0] === ':') {
      if(tx === ':excel')
        this.createExcel();
      if(tx === ':erase') {
        console.log("erase");
        window.localStorage.clear();
        this.forceUpdate();
      }
    }
    else {
      if(tx == ''){
        a.style.display = 'flex';
        b.innerHTML = 'Bonjour'
      } else {
        a.style.display = 'none';
        b.innerHTML = 'Resultats'
      }
  
      tx = tx.toLowerCase();
      tx = [tx];
  
      if(tx[0].includes('-')) {
        let tmp = tx[0].replace('-', ' ');
        tx.push(tmp)
      };

      if(tx[0].includes('é')) {
        let tmp = tx[0].replace('é', 'e');
        tx.push(tmp)
      };

      if(tx[0].includes('e')) {
        let tmp = tx[0].replace('e', 'é');
        tx.push(tmp)
      };
  
      if(tx[0].includes(' ')) {
        let tmp = tx[0].replace(' ', '-');
        tx.push(tmp)
      };
      
      const { searchReadyDatabase } = this.state;
      let answers = {};
  
      Object.keys(searchReadyDatabase).forEach( entry => {
        if(tx == entry) {
          answers[parseInt(entry)] = {};
        }
        tx.forEach(v => {
          if(searchReadyDatabase[entry].indexOf(v) != -1) {
            answers[parseInt(entry)] = {};
          }
        });
      });
  
      let c = document.getElementsByClassName('search-result');

      for (var i = 0; i < c.length; i++) {
        c[i].style.display = 'none';;
      };
  
      let sideResults = [];
  
      if(tx != '') {
        sideResults = Object.keys(answers).map(e => {
          return document.getElementById('res' + e)
        });
      }

      let all = [ ...sideResults ]; // ...markers,
      all = all.filter((v, i, s) => v != null);
      all.forEach(e => e.style.display = 'flex');
      this.setState({searchAnswers: answers});
    }    
  }

  optimizeDatabaseForSearchEngine = db => {
    api(apiConst.SAVE_EXCEL, db, (r) => {
      try{
        console.log("R serveur", r)
        window.localStorage.setItem('forbiddenWords', JSON.stringify(r.forbiddenWords));
        let sr = this.formatSearchReadyString(r.searchReady, r.forbiddenWords);
        console.log("SR DONE");
        this.setState({
          searchReadyDatabase: sr,
          sneakPeak: r.sneakPeak,
          serverProcessing: false
        });
      }
      catch(err) {
        console.log("Catched : ", err)
      }
    });

    this.setState({
      workbook: {},
      serverProcessing: true,
    });
  };

  createExcel = database => {
    const { isAdmin } = store.getState().userReducer;

    if(isAdmin) {
      let wb = XLSX.utils.book_new();
      api(apiConst.GET_EXCEL, {}, (db) => {
        console.log("DB", db)
        Object.keys(db).forEach(sheet => {
          let merges = {};
          if(db[sheet].hasMerges) {
            Object.keys(db[sheet].hasMerges).forEach(mergeName => {
              merges[mergeName] = {s: undefined, e: undefined};
              db[sheet].hasMerges[mergeName].forEach(field => {
                console.log('e',field)
                if(merges[mergeName].s == undefined)
                  merges[mergeName].s = { c: db[sheet].columnNames.indexOf(field), r: 0 };
                merges[mergeName].e = { c: db[sheet].columnNames.indexOf(field), r: 0 };
              });
            });
          };
          
          db[sheet].columnNames.unshift('HISTOLITT_V2');
          
  
          let sheetMergesProps = [];
          let mergeLine = [];
          
          Object.keys(merges).forEach(columnName => {
            for(let i = mergeLine.length; i < merges[columnName].s.c; i++)
              mergeLine.push(undefined);
            mergeLine.push(columnName);
            sheetMergesProps.push(merges[columnName]);
          });
          if(mergeLine.length > 0){
            db[sheet].content.unshift(mergeLine);
          }
          
          let content = [];
          
          db[sheet].content.forEach(line => {
            let arr = [];
            db[sheet].columnNames.forEach(columnName => {
              arr.push(line[columnName]);
            });
            content.push(arr);
          });

          db[sheet].content = content;

          db[sheet].content.unshift(db[sheet].columnNames);

          console.log('db sheet: ', db[sheet]);
          console.log('there', db[sheet].content);
          
          let ws = XLSX.utils.aoa_to_sheet(db[sheet].content);
          if(sheetMergesProps.length > 0){
            ws['!merges'] = sheetMergesProps;
          }
          console.log(ws);
          XLSX.utils.book_append_sheet(wb, ws, sheet);
        });
        XLSX.writeFile(wb, 'îles & îlots de Bretagne.xlsx');
      } );
    }
    
  };

  saveIsland = (island, newIslandObj) => {
    api(apiConst.SAVE, {key: island.ID.HISTOLITT_V2, data: newIslandObj}, (r) => {
      let srObj = {};

      Object.keys(r.searchReady).map(k => {
        srObj[k] = r.searchReady[k];
      });

      let obj = this.state.searchReadyDatabase;
      let fb = JSON.parse(window.localStorage.getItem('forbiddenWords'));
      let sr = this.formatSearchReadyString(srObj, fb);

      Object.keys(sr).map(k => {
        obj[k] = sr[k];
      });

      r.island.ID = island.ID;
      
      store.dispatch({type: SET_FOCUSED_ISLAND, focusedIsland: r.island})
      this.setState({
        focusedIsland: r.island,
        islandOverview: false
      });
    });
  }

  registerChangeInSearchReadyDatabase = (srObj, sneakPeak) => {
    let obj = this.state.searchReadyDatabase;
    let fb = JSON.parse(window.localStorage.getItem('forbiddenWords'));
    let sr = this.formatSearchReadyString(srObj, fb);

    Object.keys(sr).map(k => {
      obj[k] = sr[k];
    });

    this.setState({
      searchReadyDatabase: obj,
      sneakPeak: !!sneakPeak ? sneakPeak : this.state.sneakPeak
    });
  }

  contentFeed = () => {
    const { workbook: { workbook }, mockIsland, sneakPeak, searchAnswers } = this.state;
    
    console.log("workbook : ", workbook);
    if(workbook){
      return <DatabaseImporter workbook={workbook} validate={db => this.optimizeDatabaseForSearchEngine(db)} />
    } else {
      let isAdmin = store.getState().userReducer.isAdmin;
      return (
        <MainInterface
          sneakPeak={sneakPeak}
          searchAnswers={searchAnswers}
          saveIsland={this.saveIsland}
          isAdmin={isAdmin}
          mockIsland={mockIsland}
          registerChangeInDatabase={(primaryKey, data) => this.registerChangeInDatabase(primaryKey, data)}
          registerChangeInSearchReadyDatabase={(srObj) => this.registerChangeInSearchReadyDatabase(srObj)} />
      );
    }
  }

  connect = () => {
    store.dispatch({type: LOG});
    this.setState({ showConnection: false });
  }

  cancelConnect = () => {
    this.setState({ showConnection: false });
  }

  sendBatchImages = (images) => {
    console.log('batch Images : ', images);

    api(apiConst.SAVE_MULTIPLE_IMAGES, images);
  }

  render() {
    const { showConnection, loadingExcel } = this.state;
    const { isAdmin } = store.getState().userReducer;

    //console.log('Search Ready :', this.state.searchReadyDatabase)
    //console.log('Main state: ', this.state);
    //console.log('Main Props : ', this.props);
    //console.log('Is Admin :', isAdmin);
    
    
    return(
      <Provider store={store}>
        <div style={{ flexDirection: 'column', maxWidth: '100vw' }}
          onDragOver={e => e.preventDefault()}
          onDrop={event => {
            event.preventDefault();
            let pi = document.getElementById('page-island');
            if(!pi && isAdmin) {
              let fileType = event.dataTransfer.files[0].type;
              console.log('t', fileType)
              if(fileType == 'image/png' || fileType == 'image/jpg' || fileType == 'image/jpeg') {
                handleDrop(event, (images) => {
                  console.log(typeof images)
                  this.sendBatchImages(images);
                })
              }
              else if(fileType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                console.log('droped excel');
                this.setState({loadingExcel: true})
                handleDrop(event, (workbook) => {
                  console.log(workbook)

                  console.log(this.state)
                  this.setState({ workbook, loadingExcel: false });
                })
              }
            }
          }}>
            <div id='header' className='shadow'>
              <SiteLogo searchMethod={tx => this.searchFor(tx) } showConnection={() => {
                this.setState({ showConnection: true });
                }}
                isAdmin={isAdmin}
                refresh={() => {
                  this.forceUpdate()
                }}/>
              <ServerLoading loading={this.state.serverProcessing} />
            </div>
            
            <div  className={showConnection || loadingExcel ? 'blurred' : ''} id='content'>
              {this.contentFeed()}
            </div>
            {
              !!showConnection
              ? <Account validate={(u, p) => this.connect()} cancel={() => this.cancelConnect() } />
              : null
            }
            {
              loadingExcel
              ? <Mask>
                  <SyncLoader color={'#eee'} />
                  <div style={{width: 10}}/>
                  Préparation du fichier
                </Mask>
              : null
            }
        </div>
      </Provider>
      
    );
  }
}

export default hot(Main);

const wrapper = document.getElementById('root');
wrapper ? ReactDOM.render(<Main/>, wrapper) : false;